module.exports = __webpack_public_path__ + "img/parts_dragging.73721cc2.svg";